<template>
    <div class="container py-4" v-show="user.id && $store.state.user">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="warning small text-danger" v-if="!verifiedUser && !$store.getters.isGuest">
                    {{user.name}} さんのメールアドレスが承認されていません。
                    メールアドレスが承認されるまで、サブドメインの取得が行えません。
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <div class="account">
                    <div class="d-flex flex-row">
                        <img :src="user.profile_url + '?' + user.profile_hash" class="img-fluid img-thumbnail d-block cover-img" v-if="user.profile_url" />
                        <div class="ml-3">
                            <h5 class="mb-3 font-weight-bold">
                                <i class="fas fa-user-secret text-danger" v-if="isImpersonate"></i>
                                <ruby>
                                    {{user.name}}
                                    <rt>{{user.kana}}</rt>
                                </ruby>
                                <span v-if="!user.rating" class="badge badge-secondary badge-sm">無し</span>
                                <span v-else class="badge badge-sm" :class="['badge-' + user.rating.color]">{{user.rating.rating_name}}</span>
                            </h5>
                            <h6 v-if="user.subdomain">
                                <a :href="'//' + user.subdomain + $store.state.base_domain" target="_blank">
                                    <span v-html="$filters.ruby(user.bookshelf_name || '自分の本棚')"></span>
                                    <span class="small">
                                        <i class="fas fa-external-link-alt"></i>
                                    </span>
                                </a>
                            </h6>
                            <h6 v-else-if="$store.getters.isGuest">
                                <router-link to="/mypage/account/register" class="text-success">
                                    <i class="fas fa-user"></i>
                                    正規登録はこちら
                                </router-link>
                            </h6>
                            <h6 v-else-if="!verifiedUser">
                                <router-link to="/mypage/account" class="text-danger">
                                    メールアドレスを承認してください
                                </router-link>
                                <div class="small py-2">
                                    メールアドレスを承認したらページを再読み込みしてください。
                                </div>
                            </h6>
                            <h6 v-else>
                                <router-link to="/mypage/account">
                                    サブドメインを登録しましょう
                                </router-link>
                            </h6>
                            <h6 v-if="$store.getters.isGuest">
                                <router-link to="/help/account/guest" class="text-primary">
                                    <i class="fas fa-vial"></i>
                                    お試し登録について
                                </router-link>
                            </h6>
                        </div>
                    </div>
                    <div class="mb-3 mt-4" v-if="!$store.getters.isGuest">
                        <router-link to="/mypage/account" class="btn btn-outline-secondary btn-sm btn-block">
                            <i class="fas fa-user-circle"></i>
                            アカウント設定
                        </router-link>
                    </div>
                    <div class="mb-3" v-if="user.subdomain">
                        <router-link to="/mypage/backlinks" class="btn btn-outline-secondary btn-sm btn-block">
                            <i class="fas fa-link"></i>
                            バックリンク
                        </router-link>
                    </div>
                </div>
                <a href="#" @click.prevent="toggleMenu()" class="menu-opener">
                    <span v-if="!isMenuOpen">
                        メニューを開く
                        <i class="fas fa-chevron-right"></i>
                    </span>
                    <span v-else>
                        メニューを閉じる
                        <i class="fas fa-chevron-down"></i>
                    </span>
                </a>
                <div class="sticky">
                    <ul class="menus" :class="{'menu-opened': isMenuOpen}">
                        <li>
                            <router-link to="/mypage/histories">
                                履歴
                            </router-link>
                        </li>
                        <li v-if="verifiedUser && hasSubdomain">
                            <router-link to="/mypage/genres">
                                ジャンル
                            </router-link>
                        </li>
                        <li v-if="verifiedUser && hasSubdomain">
                            <router-link to="/mypage/series">
                                シリーズ
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/favorites">
                                お気に入り
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/reviews/sent">
                                送った感想
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/reviews/received">
                                受け取った感想
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/followees">
                                フォロー
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/tickets">
                                お問い合わせ
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/notices">
                                お知らせ
                            </router-link>
                        </li>
                        <li v-if="verifiedUser">
                            <router-link to="/mypage/invitees">
                                招待履歴
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/mypage/backgrounds/portal">
                                ポータル背景設定
                            </router-link>
                        </li>
                        <li v-if="user.subdomain">
                            <router-link to="/mypage/backgrounds/bookshelf">
                                本棚背景設定
                            </router-link>
                        </li>
                    </ul>
                    <ul class="menus admin" v-if="isRoot">
                        <li>
                            <router-link to="/admin/notices" class="text-danger">
                                <i class="fas fa-info-circle"></i>
                                お知らせ管理
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/admin/users" class="text-danger">
                                <i class="fas fa-users"></i>
                                ユーザー管理
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/admin/tickets" class="text-danger">
                                <i class="fas fa-question-circle"></i>
                                お問い合わせ管理
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/admin/pictures/all" class="text-danger">
                                <i class="fas fa-images"></i>
                                画像管理
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/admin/alert" class="text-danger">
                                <i class="far fa-comment-dots"></i>
                                アラート
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-9">
                <ul class="tab">
                    <li :class="{active: $route.path.match(/\/mypage\/books.*/) || $route.path == '/mypage'}">
                        <router-link to="/mypage/books" class="text-reset">
                            小説
                        </router-link>
                    </li>
                    <li :class="{active: $route.path.match(/\/mypage\/article/)}" v-if="hasSubdomain">
                        <router-link :to="'/mypage/articles' + articlePage" class="text-reset">
                            記事
                        </router-link>
                    </li>
                    <li :class="{active: $route.path.match(/\/mypage\/pickups/)}" v-if="hasSubdomain">
                        <router-link to="/mypage/pickups" class="text-reset">
                            ピックアップ
                        </router-link>
                    </li>
                    <li :class="{active: $route.path.match(/\/mypage\/notes/)}">
                        <router-link to="/mypage/notes" class="text-reset">
                            ノート
                        </router-link>
                    </li>
                    <li :class="{active: $route.path.match(/\/mypage\/news/)}">
                        <router-link to="/mypage/news" class="text-reset">
                            一言
                        </router-link>
                    </li>
                </ul>
                <router-view v-slot="{ Component }">
                    <transition mode="out-in">
                        <component :is="Component" />
                    </transition>
                </router-view>
            </div>
        </div>

        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.container {
    max-width: 1480px;
}
.badge-sm {
    font-size: 0.6rem;
}
.cover-img {
    width: 80px;
    height: 80px;
    object-fit: cover;
}
.account {
    border: 1px solid #ddd;
    padding: 1rem;
    border-radius: .7rem;;
}
.warning {
    background-color: #eee;
    border-radius: .5rem;
    margin: 1rem 0;
    padding: 1rem;
}
.tab {
    padding-inline-start: 0;
    list-style: none;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0 0 2.5rem;
    li {
        display: inline-block;
        a {
            padding: 1rem;
            &:hover {
                text-decoration: none;
                border-bottom: 2px solid #5a5a6a;
            }
        }
        &.active {
            a {
                border-bottom: 2px solid #5a5a6a;
                &:hover {
                    text-decoration: none;
                    border-bottom: 2px solid #aaa;
                    color: #777;
                }
            }
        }
    }
}

.menus {
    margin: 1rem 0;
    padding-inline-start: 0;
    list-style: none;
    font-size: .9rem;
    &.admin {
        a {
            color: #be0c0c;
            font-weight: bold;
        }
    }
    li {
        a {
            padding: .5rem 1rem;
            display: block;
            color: #1a1a2a;
            text-decoration: none;
            border-radius: .7rem;
        }
    }
}
.menu-opener {
    display: none;
}
@media screen and (max-width: 992px) {
    .tab {
        font-size: .9rem;
        margin-top: 2rem;
        li {
            a {
                padding: .5rem .35rem;
            }
        }
    }
    .menus {
        display: none;
        font-size: .9rem;
        &.menu-opened {
            display: block;
            margin: 0 0 2rem;
        }
        li {
            a {
                padding: .5rem;
            }
        }
    }
    .menu-opener {
        display: block;
        padding: 1rem 0;
        text-decoration: none;
    }
}
</style>

<script>
export default {
    data() {
        return {
            user: {},
            isLoading: false,
            isMenuOpen: false,
        };
    },
    methods: {
        load() {
            this.isLoading = true;
            // 最新のユーザー情報
            axios.get("/mypage/get").then(res => {
                this.user = res.data;
            }).catch(err => {
                alert.err(err.response);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
    },
    computed: {
        isRoot() {
            return this.$store.state.user?.is_root || this.$store.state.user?.impersonate;
        },
        isImpersonate() {
            return this.$store.state.user?.impersonate;
        },
        verifiedUser() {
            return this.$store.state.user && this.$store.state.user.email_verified_at;
        },
        hasSubdomain() {
            return this.$store.state.user && this.$store.state.user.subdomain;
        },
        articlePage() {
            if (this.$route.path.match(/\/mypage\/article/)) {
                if (this.$route.query.page) {
                    return "?page=" + this.$route.query.page;
                }
            }
            return "";
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.useHead({
                title: "マイページ | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>